export default __webpack_public_path__ + "static/audio/temp2.55917b.mp3";